import type { FC } from 'react'
import { useMemo } from 'react'

import { ScopedCssBaseline } from '@mui/material'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { Outlet } from 'react-router-dom'

import { getThemeByMode } from '@/common/theme'

export const DocsLayout: FC = () => {
  const darkTheme = useMemo(() => getThemeByMode('dark'), [])

  return (
    <MuiThemeProvider theme={darkTheme}>
      <ScopedCssBaseline>
        <Outlet />
      </ScopedCssBaseline>
    </MuiThemeProvider>
  )
}
